export function onlyNumbers(value) {
  return String(value || "").replace(/\D+/g, "");
}
